import React from 'react';
import PropTypes from 'prop-types';

import './TextInput.scss';

const TextInput = ({ icon, clearInput, ...props }) => (
  <div className="text-input">
    { icon && <i className={`text-input__icon text-input__icon-${icon}`} /> }
    <input type="text" className="text-input__input" {...props} />
    { props.value && <a href="" onClick={clearInput} className="text-input__clear-input"><span className="hide-text">Clear search</span></a> }
  </div>
);

TextInput.propTypes = {
  icon: PropTypes.string,
  clearInput: PropTypes.func,
  value: PropTypes.string,
};

TextInput.defaultProps = {
  icon: '',
  value: '',
  clearInput: () => {},
};

export default TextInput;



// WEBPACK FOOTER //
// ./components/TextInput/TextInput.js